module.exports = __webpack_public_path__ + "assets/remove-students.f7cf1646.svg";